import { useQuery } from "@tanstack/react-query";
import { getMeetingNotesTemplates } from "../api/meetingNotesTemplates";

// Every Sidekick user can read this (the summarise picker needs it), not just
// admins. `data` holds the customer's own templates; `meta` carries the
// built-in prompt plus which template is the customer default and which one
// this user would get if they didn't pick one.
export const useMeetingNotesTemplates = () => {
  const { data, isLoading, isLoadingError, isFetching, refetch } = useQuery(
    ["meeting-notes-templates"],
    () => getMeetingNotesTemplates(),
    {
      staleTime: 60000,
    },
  );

  return {
    templates: data?.data?.data ?? [],
    meta: data?.data?.meta ?? {},
    isLoading,
    // Callers need to tell a failed fetch apart from a customer with no
    // templates: both leave `templates` empty, but only one is worth a retry.
    // isLoadingError, not isError, so a failed background refetch doesn't tear
    // down a screen that still has perfectly good data to show.
    isError: isLoadingError,
    isFetching,
    refetch,
  };
};
